export async function clearCache(): Promise<void> {
  if ('serviceWorker' in navigator) {
    const keys = await window.caches.keys();

    keys.forEach((cacheName) => {
      caches.delete(cacheName);
    });
  }
}
